// extracted by mini-css-extract-plugin
module.exports = {"label":"label--4ESPK","disabledLabel":"disabledLabel--9tEBZ"};